import { create } from 'zustand'

type Store = {
  selectedDsaId: number | null
  setSelectedDsaId: (payload: number) => void
}
const useDsaStore = create<Store>((set) => ({
  selectedDsaId: null,
  setSelectedDsaId: (payload) =>
    set((state) => ({ ...state, selectedDsaId: payload })),
}))

export default useDsaStore
